import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {RuoloUtenteEnum} from '../../../../model/enum.model';
import {AuthenticationService} from '../../../../services/authentication/authentication.service';

@Injectable()
export class ControlloreRxArcoSnifferGuard implements CanActivate {

  constructor(private router: Router, protected authService: AuthenticationService) {}

  canActivate(next: ActivatedRouteSnapshot) {
    if (this.authService.currentUser()
      && (this.authService.currentUser().ruoli.find(r => r.codice === RuoloUtenteEnum.CONTROLLORE_RX_SN_AR)
        || this.authService.currentUser().ruoli.find(r => r.codice === RuoloUtenteEnum.ADMIN))) {
      return true;
    }

    return this.router.parseUrl('/app/login');
  }
}
